import { type FC, ReactNode } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { schema, TruckStepOneSchema } from "./stepOneSchema";

type Props = {
	children: ReactNode;
	defaultValues?: TruckStepOneSchema;
};

const TruckFormProvider: FC<Props> = ({ children, defaultValues }) => {
	const methods = useForm({
		resolver: yupResolver(schema),
		defaultValues: defaultValues ?? {
			truckName: undefined,
			stops: [{ address: undefined }]
		}
	});

	return <FormProvider {...methods}>{children}</FormProvider>;
};

export default TruckFormProvider;
